import axios from "axios";
import React, {Component} from "react";
import FeatherIcon from 'feather-icons-react';
import Select from 'react-select';
import ShoolfeeInvoice from "./ShoolfeeInvoice";
import { toast } from "react-toastify";
import Styleselect from "../../Styleselect";
import ReactLoading from "react-loading";
import Modal from "react-bootstrap/Modal";
import StudentForm from "../students/StudentForm";
import StudentFormrh  from "../../rh/students/StudentForm";
import { getBranding } from "../../../theme/branding";

const establishment = getBranding()
const displayName = (mois, trimestre) => (establishment?.type == 1 ? (mois || trimestre) : (trimestre || mois))
        
class   Formschoolfee extends Component{

    state = {
        student : null,
        classe : null,
        price : null,
        yearId : null,
        monthsSelected : [],
        student_ : null,
        responsible : null,
        pay_mount : "",
        createdAt : null,
        search : "",
        tel : "",
        loadingSearch : false,
        schoolfeecategory : null,
        sectionschoolfeecategoryId : null,
        selectedDate : null,
        section : null,
        transport : null,
        isModal : false,
        isModalAdd : false,
        isModalCheck : false,
        isModalEditStudent : false,
        formData : null,
        formData_ : null,
        students : [],
        searchs : [],
        months : [],
        sections : [],
        years : [],
        schoolfeecategories : [],
        invoiceStudent : [],
        invoices : [],
        btn : false,
        transport__  : false,
        loading : false,
        printInvoice : false
    }

    componentDidMount(){
        this.getInvoices(this.state.selectedDate);
        this.getMonths();
        this.getYears();
        this.getSchoolfeecategories()
        this.getSections()
    }

    async getMonths(){
        let request = await axios.get('months');
        if(request.status === 200)
            this.setState({months : request.data})
    }

    async getYears(){
        let request = await axios.get('years');
        if(request.status === 200) 
            this.setState({years : request.data, yearId : request.data[request.data?.length -1]?.id})
    }

    async getSchoolfeecategories(){
        let request = await axios.get('schoolfeecategories');
        if(request.status === 200)
            this.setState({
                schoolfeecategories : request.data, 
            })
    }

    async getSections(){
        let request = await axios.get('sections');
        if(request.status === 200)
            this.setState({sections : request.data})
    }

    async getStudentInvoice(student = null){
        let request = await axios.get(`schoolfee/$student.id$/${ encodeURI(student) }`)
        if(request.status == 200){
            this.setState({ invoiceStudent : request.data })
        }else
            this.setState({ invoiceStudent : [] })
    }

    async getInvoices(date = null){
        this.setState({ loading : true })
        let request = await axios.get(`schoolfee/createdAt/${ encodeURI(date || new Date()?.toISOString()) }`)
        if(request.status == 200){
            this.setState({ invoices : request.data })
        }
        this.setState({ loading : false })
    }

    handleInputMax = (e) => {
        const totalPrice = (this.state.monthsSelected || []).reduce(
            (total, month) => total + Number(month.price || 0),
            0
        );

        if (
            this.state.schoolfeecategory &&
            Number(e.target.value) > 0 &&
            Number(e.target.value) <= totalPrice
        ) {
            this.setState({
                [e.target.name]: e.target.value
            });
        } else {
            this.setState({
                [e.target.name]: ""
            });
        }
    }

    handleInputChange = (select) => {
        this.setState({
            classe : select.value,
            students : select.value.students,
            // student : "",
            section : select.section,
            transport : select.transport,
            sectionschoolfeecategoryId : select.sectionschoolfeecategoryId,
            price : "",
            pay_mount : "",
            monthsSelected : [],
        })
        window.scrollTo({top: 0, left: 0, behavior: 'smooth'})
    }

    handleInputChangeSearch = async(e) => {
        this.setState({
            search : e.target.value,
            loadingSearch : true
        })
        if(e.target?.value?.length > 3 && e.target?.value?.length % 2 == 0){
            let request = await axios.get(`/studentsearchs/${ encodeURIComponent(e.target.value) }/${ encodeURIComponent(this.state.yearId) }`)
            if(request.status == 200){
                this.setState({
                    search : e.target.value,
                    searchs : request.data,
                    loadingSearch : false
                })
            }
        }
    }

    displayInvoice = (date = null) => {
        this.setState({
            selectedDate : date
        })
        this.getInvoices(date)
    }

    showModalSendSms = async(da) => {
        let sms = await axios.get("smssend/"+da);
        if(sms.status === 200)
        {
            toast(sms.data?.msg, { theme : "light", style : { backgroundColor : "blue", color : "white"}})
            this.getInvoices(this.state.selectedDate)
            
        }else{
            toast(sms?.data?.msg, { theme : "light", style : { backgroundColor : "red", color : "white"}})
        }
    }

    showModal = (schoolfee = null) => {
        this.setState({
            isModal : !this.state.isModal,
            formData : schoolfee,
        })
    }

    showModalAdd = (va = null, val = null, add = null) => {
        this.setState({
            isModalAdd : !this.state.isModalAdd
        })
        if(add == 1)
            this.getSections()
    }

    editStudentModal = (student = null) => {
        this.setState({
            isModalEditStudent : !this.state.isModalEditStudent,
            formData_ : student,
        })
        if(student == 1){
            this.getSections()
        }
    }



    showModalCheck = (student = null) => {
        this.setState({
            isModalCheck : !this.state.isModalCheck
        })
        if(student){
            this.setState({
                classe : student.sectionclass,
                student : student?.id,
                student_ : student,
                tel : student?.user?.user?.tel,
                responsible : student?.user?.user?.id,
                isModalCheck : false
            })
            this.getStudentInvoice(student?.id)
        }
    }

    showModalCheck_edit = (student = null) => {
        this.setState({
            isModalCheck : !this.state.isModalCheck
        })
        if(student){
            this.setState({
                classe : student.sectionclass,
                student : student?.id,
                student_ : student,
                tel : student?.user?.user?.tel,
                responsible : student?.user?.user?.id,
                isModalCheck : false
            })
            this.getStudentInvoice(student?.id)
            this.editStudentModal()
        }
    }

    storeShoolfee = async () => {
        const selectedMonths = this.state.monthsSelected || [];

        if (selectedMonths.length === 0) {
            toast("Veuillez sélectionner au moins un "+ displayName("mois", "trimestre"), {
                theme: "light",
                style: {
                    backgroundColor: "red",
                    color: "white"
                }
            });
            return;
        }

        let remainingAmount = parseFloat(this.state.pay_mount || 0);

        if (remainingAmount <= 0) {
            toast("Veuillez saisir un montant", {
                theme: "light",
                style: {
                    backgroundColor: "red",
                    color: "white"
                }
            });
            return;
        }

        this.setState({ btn: true });

        try {
            for (const month of selectedMonths) {

                if (remainingAmount <= 0) {
                    break;
                }

                const price = parseFloat(month.price || 0);

                if (price <= 0) {
                    continue;
                }

                // Montant affecté à ce mois/trimestre
                const amountToPay = Math.min(remainingAmount, price);

                let data = {
                    userId: this.state.responsible,

                    sectionclasseId: this.state.classe
                        ? this.state.classe.id
                        : this.props.classe.sectionclasse,

                    studentId: this.state.student,

                    sectionschoolfeecategoryId: month.value,

                    monthId: [month],

                    pay_mount: amountToPay,

                    createdAt: this.state.createdAt
                        ? new Date(this.state.createdAt)
                        : null,

                    remaining_amount: 0,// price - amountToPay,

                    tel: this.state.tel,

                    operation: "Ajouter",
                };

                if (this.state.yearId) {
                    data.yearId = this.state.yearId;
                }

                const response = await axios.post("schoolfees", data);

                toast(response?.data?.msg, {
                    theme: "light",
                    style: {
                        backgroundColor: "blue",
                        color: "white"
                    }
                });

                // Montant qui reste à affecter au prochain mois/trimestre
                remainingAmount -= amountToPay;

                // Impression de chaque reçu séparément
                if (this.state.printInvoice && response?.data?.data?.id) {
                    await this.printToPOS(response.data.data.id);
                }
            }

            // Nettoyage après tous les paiements
            this.setState({
                btn: false,
                pay_mount: "",
                monthsSelected: [],
                transport__: false
            });

            // Actualisation
            this.getStudentInvoice(this.state.student);
            this.getInvoices(this.state.selectedDate);

        } catch (error) {

            this.setState({
                error: error.response?.data?.msg,
                btn: false
            });

            toast(error.response?.data?.msg || "Erreur lors du paiement", {
                theme: "light",
                style: {
                    backgroundColor: "red",
                    color: "white"
                }
            });
        }
    }

    delete = (gift) =>{
        axios.delete("gifts/"+gift).then((response) => {
            this.getInvoices(this.state.selectedDate)
            toast(response?.data?.msg, { theme : "light", style : { backgroundColor : "blue", color : "white"}})
        }).catch((error)=>{
            toast(error.response?.data?.msg, { theme : "light", style : { backgroundColor : "red", color : "white"}})
        })
    }

    handleCheck(val) {
        let permissions = localStorage.getItem("permissions") ? JSON.parse(localStorage.getItem("permissions")) : [];
         return  permissions.some(item => val === item.permission);
     }
     
    printToPOS = async(val = null) => {
        let text = ""
        let schoolfee = await axios.get("schoolfees/"+val);
        if(schoolfee.status === 200)
        {
            schoolfee = schoolfee.data
            let Months = ['Janvier', 'Fevrier', 'Mars', 'Avril', 'Mai', 'Juin', 'Juillet', 'Aout', 'Septembre', 'Octobre', 'Novembre', 'Decembre']
            text +=  `${ schoolfee?.student?.sectionclass?.section?.establishment?.name  }\n`
            text += `_________________\n`
            if(schoolfee?.student?.sectionclass?.section?.establishment?.tax_center){
                text +=  `${ schoolfee?.student?.sectionclass?.section?.establishment?.tax_center || ''  }\n`
                // text += `.................\n\n`
            }
            text += `Adress : ${ schoolfee?.student?.sectionclass?.section?.establishment?.other_adress }\n`
            text += `Télé : ${ schoolfee?.student?.sectionclass?.section?.establishment?.tel }\n`
            // text += `Email : ${ schoolfee?.student?.sectionclass?.section?.establishment?.email }\n`
            text += `.................\n\n`
            text += `Matr. ID : ${ schoolfee?.student?.matricule }\n`
            text += `Elève : ${ (schoolfee?.student?.user?.last_name || '') } ${ (schoolfee?.student?.user?.family_name || '') } ${ (schoolfee?.student?.user?.first_name || '') }\n`
            // text += `Parent : ${ (schoolfee?.student?.user?.user?.last_name  || '') } ${ (schoolfee?.student?.user?.user?.family_name  || '') } ${ (schoolfee?.student?.user?.user?.first_name  || '') }\n`
            // text += `Télé parent: ${ (schoolfee?.student?.user?.user?.tel  || '') }\n`
            text += `_________________\n`
            text += ` \t  RECU N°. ${ schoolfee?.invoice }\n \n`
            
            text += `Année scolaire : ${ schoolfee?.year?.year }\n`
            // text += `Section/option : ${ schoolfee?.student?.sectionclass?.section?.short_entitled_section }\n`
            text += `Classe : ${ schoolfee?.student?.sectionclass?.class?.short_entitled_class } ${ schoolfee?.student?.sectionclass?.title} ${ schoolfee?.student?.sectionclass?.section?.short_entitled_section }\n\n`

            text += `La somme de : ${ schoolfee?.pay_mount + "" + schoolfee?.sectionschoolfeecategory?.currency }\n`
            text += `Motif : ${ schoolfee?.sectionschoolfeecategory?.schoolfeecategory?.category }  ${ (schoolfee?.sectionschoolfeecategory?.transport?.axe || "")}\n`
            text += `Echéance : ${  displayName(schoolfee?.month?.month, schoolfee?.trimesectschool?.trimester?.short_trimester) }\n`
            // text += `Payé le : ${ new Date(schoolfee?.createdAt)?.getDate() } ${ Months[new Date(schoolfee?.createdAt)?.getMonth()]} ${ new Date(schoolfee?.createdAt)?.getFullYear() } ${ new Date(schoolfee?.createdAt)?.getHours() }h:${ new Date(schoolfee?.createdAt)?.getMinutes() }\n`
            text += schoolfee?.remaining_amount > 0 ? `Dette restante du ${  displayName(schoolfee?.month?.month, schoolfee?.trimesectschool?.trimester?.short_trimester) } : ${ schoolfee?.remaining_amount + "" + schoolfee?.sectionschoolfeecategory?.currency}\n` : ``
            text += schoolfee?.dette > 0 ? `Dette totale: ${ schoolfee?.dette + "" + schoolfee?.sectionschoolfeecategory?.currency}\n` : ``
                
            text += `------------------\n`
            text += `Par : ${ (this.state.schoolfee?.staff?.user?.last_name  || '') } \n`
            
            // text += `Merci et bienvenue encore\n\t\n`
            text += `Print ${ new Date(schoolfee?.createdAt)?.toLocaleDateString("en-GB") } ${ new Date()?.getHours() }h:${ new Date()?.getMinutes() }`
            text += `\n©By Evive Digital\n\n`
            
            const devices = await navigator.usb.getDevices();
            if (devices.length > 0) {
                try {
                    const device = await navigator.usb.requestDevice({
                    filters: [{ vendorId: localStorage.getItem("vendorId") }] // remplace par l’ID de ton imprimante
                    // filters: [{ vendorId: 0x04b8 }] // remplace par l’ID de ton imprimante
                    })
                    await device.open();
                    await device.selectConfiguration(1);
                    await device.claimInterface(0);
    
                    const encoder = new TextEncoder();
                    const data = encoder.encode(`<pre>${ text }</pre>`);
                    await device.transferOut(1, data); // endpoint à adapter
                } catch (err) {
                    console.error("Erreur impression :", err);
                }
            }else{
                let invoices = window.open("", "_blank", "width=600,height=300")
                invoices.document.write(`<pre>${ text }</pre>`)
                invoices.document.close()
                invoices.print()
            }
        }
        
    }
      
    render(){
        const selectMenuProps = {
            menuPortalTarget: typeof document !== "undefined" ? document.body : null,
            menuPosition: "fixed",
            classNamePrefix: "student-select",
            styles: { menuPortal: (base) => ({ ...base, zIndex: 1060 }) },
        };

        const yearId = this.state.yearId ? this.state.yearId : this.state.years[this.state.years?.length -1]?.id

        const user = localStorage.getItem("user") ? JSON.parse(localStorage.getItem("user")) : {};

        let optionsectionclasses = [], optionschoolfees= [] , optionschoolfeecategories= [] , optionmonths = [], optionprofiles= [] , optionstudents= [];
        
        this.state.schoolfeecategories?.map(val => {
            optionschoolfees.push({
                value : val,
                label : val.category
            })
        })

        this.state.students?.map((student) => {
            let user_id =  student.user?.user?.id;
            optionstudents.push({
                value : student.id, 
                label : student.matricule + " " + student.user.last_name + " " + (student.user.family_name || "") + "  " + (student.user.first_name || ""), user_id : user_id,
                student_ : student,
                tel : student.user?.user?.tel,
                sectschoolfeecatstudcategories : student.sectschoolfeecatstudcategories
            })
        })

        this.state.months?.sort((a, b) => a.trimester?.short_trimester < b.trimester?.short_trimester ? -1 : 1).map((month) => {
            if(optionmonths?.filter(v => v.trimesterId == month.trimester?.id)?.length == 0)
                optionmonths.push({ value : month.id, trimesterId : month.trimester?.id, label : month.trimester?.short_trimester})
        })

        this.state.students?.length > 0 && (
            this.state.schoolfeecategories.filter(dat => dat.id == this.state.schoolfeecategory?.id).map((choolfeecategory) => {
                return(
                    choolfeecategory.sectionschoolfeecategories?.filter(va => va.status == "Actif").map((data) => {
                        let categorie = "", price = data.price;
                        this.state.sectschoolfeecatstudcategories?.filter(val => val.sectschoolfeecatstudentcat.sectionschoolfeecategory.id == data.id).map((value) => {
                            categorie = " / "+ value.sectschoolfeecatstudentcat.price  + " "+data.currency+ " "+ value.sectschoolfeecatstudentcat.categorystudent.category_student;
                            price = value.sectschoolfeecatstudentcat.price;
                        })
                        optionschoolfeecategories.push({ 
                            sectionId : data.section?.id, 
                            transportId : data.transport?.id ? data.transport?.id : null,
                            value : data.id, 
                            label : (data.transport?.axe || data.section?.short_entitled_section) + " "+data.price + " "+data.currency + " " + categorie, 
                            price : price > 0 ? price : data.price,
                            currency : data.currency
                        })
                    })
                )
            })
        )

        if(this.state.schoolfeecategory)
        {
            this.state.schoolfeecategory?.sectionschoolfeecategories?.filter(va => va.status == "Actif").map(va => {
                this.state.sections?.filter(v => v.id == va.section?.id || va.transport?.id)?.map(section => {
                    section?.sectionclasses?.map((sectionclasse) =>{
                        if(optionsectionclasses?.filter(v => v.value?.id == sectionclasse?.id)?.length == 0){
                            optionsectionclasses.push({
                                sectionschoolfeecategoryId : va.id,
                                value : sectionclasse, 
                                label : sectionclasse.class.short_entitled_class + " " + sectionclasse.title +" "+ section?.short_entitled_section + " " + section.entitled_section,
                                section : section,
                                transport : va.transport
                            })
                        }
                    })
                })
            })
        }

        let trimesections = []
        this.state.schoolfeecategories.map((choolfeecategory) => {
            return(
                choolfeecategory.sectionschoolfeecategories?.filter(dat => dat.status == "Actif" && dat.id == this.state.sectionschoolfeecategoryId)?.map((data) => {
                    let categorie = "", price = '' // data.price;
                    data.trimesectschools?.sort((a, b) => a.trimester?.short_trimester < b.trimester?.short_trimester ? -1 : 1).map((val_) => {
                        trimesections.push({ value : val_.id, trimesterId : val_.trimester?.id, label : val_.trimester?.short_trimester + " "+val_.price + " "+data.currency + " " + categorie, price : val_.price > 0 ? val_.price : 0 })
                    })
                })
            )
        })

        let currencies = []
        // this.state.invoices?.filter(v => v.staff?.id == user?.staff?.id)?.map((val) =>{
        this.state.invoices?.map((val) =>{
          if(currencies.filter(cur => cur?.currency == val.sectionschoolfeecategory?.currency)?.length == 0)
            currencies.push(val.sectionschoolfeecategory)
        })

        let mount = 0, valprice =
        currencies.map((curr => {
          mount = 0
        //   this.state.invoices?.filter(val => val.staff?.id == user?.staff?.id && curr?.currency == val.sectionschoolfeecategory?.currency).map((val) =>(
          this.state.invoices?.filter(val =>  curr?.currency == val.sectionschoolfeecategory?.currency).map((val) =>(
            mount += parseFloat(val.pay_mount || 0)
          ))
          
          if(mount > 0)
            return(
                <span className="schoolfee-pay-total">
                   { mount > 0 ? mount?.toFixed(2)?.toLocaleString()+" " + curr?.currency : "" } 
                </span>
            )
        }))

        const totalSelectedAmount = (this.state.monthsSelected || []).reduce(
            (total, month) => total + Number(month.price || 0),
            0
        );

        return(
            <div className="schoolfee-pay-page">
            
            <div className="row m-0 schoolfee-pay-layout">
                <div className="col-lg-4 col-12 m-0 p-0">
                    <div className="borderForm schoolfee-pay-card">
                        <div>
                            <label className="font-monospace fw-normal">
                                <button type="button" onClick={() => this.showModalCheck()} className="btn btn-sm btn-primary p-0 mb-1 fw-700 ms-4"><FeatherIcon icon="search" size={14}></FeatherIcon> élève</button>
                                { this.state.student_ &&( <button className="btn btn-sm btn-primary p-0 mb-1 fw-700 ms-4" onClick={() => this.editStudentModal()}>Editer { this.state.student_?.user?.last_name?.slice(0, 6) }</button> )}
                            </label>
                        </div>
                        
                        <div className="row">
                            <div className=" mt-0">
                                <label className="font-monospace fw-normal">
                                    <spane>Frais<span className="text-danger">*</span></spane>
                                  </label>
                                <Select
                                    {...selectMenuProps}
                                    value = {
                                        optionschoolfees.filter(option => 
                                            this.state.schoolfeecategory && option.value && option.value.id == this.state.schoolfeecategory?.id)
                                    }
                                    defaultValue={this.state.schoolfeecategory}
                                    onChange={
                                        (select) => {
                                            this.setState({
                                                schoolfeecategory : select.value,
                                                section : null,
                                                price : null,
                                                transport__ : false,
                                                pay_mount : "",
                                                monthsSelected : [],
                                            })

                                            if(this.state.classe && optionsectionclasses?.length > 0){
                                                this.handleInputChange(optionsectionclasses.filter(option => this.state.classe && option.value && option.value.id == this.state.classe.id)[0])
                                            }

                                            window.scrollTo({top: 0, left: 0, behavior: 'smooth'})
                                        }
                                    }
                                    styles={Styleselect}
                                    options={optionschoolfees}
                                />
                            </div>

                            <div className="row p-0 m-0">
                                <div className="mt-1 col-5">
                                    <label className="font-monospace fw-normal">Année </label>
                                    <Select
                                        {...selectMenuProps}    
                                        placeholder={ this.state.yearId ? this.state.years.filter(year => year.id == this.state.yearId)[0]?.year : "Encours"}
                                        defaultValue={this.state.yearId}
                                        onChange={
                                           (select) => this.setState({ yearId : select.value })
                                        }
                                        styles={Styleselect}
                                        options={this.state.years?.map((year) => {
                                            return { value : year.id, label : year.year }
                                        })}
                                    />
                                </div>
                                <div className="mt-1 col-7">
                                    <label className="font-monospace fw-normal"><span>Classe<span className="text-danger">*</span></span> <span style={{ color : "blue"}}>{ this.state.price }</span></label>
                                    <Select
                                        {...selectMenuProps}    
                                        placeholder={  this.state.classe ?  this.state.classe.class ? this.state.classe.class.short_entitled_class + " " + this.state.classe.title :  "" : ""}
                                        value = {
                                            optionsectionclasses.filter(option => this.state.classe && option.value && option.value.id == this.state.classe.id)
                                        }
                                        defaultValue={this.state.classe}
                                        // onInputChange={this.handleInputChange(optionsectionclasses.filter(option => this.state.classe && option.value && option.value.id == this.state.classe.id)[0])}
                                        onChange={
                                            this.handleInputChange
                                        }
                                        styles={Styleselect}
                                        options={optionsectionclasses}
                                    />
                                </div>
                            </div>

                            <div className="mt-1">
                                <label className="font-monospace fw-normal"><span>Elève<span className="text-danger">*</span></span> </label>
                                <div className=" ">
                                    <Select 
                                        {...selectMenuProps}    
                                        value = {
                                            optionstudents.filter(option => 
                                            option.value == this.state.student)
                                        }
                                        defaultValue={this.state.student}
                                        placeholder={ (this.state.student_) ? this.state.student_?.user?.last_name + ' ' + this.state.student_?.user?.family_name : ''}
                                        onChange={
                                            (select) => {
                                                this.setState({
                                                    student : select.value,
                                                    student_ : select.student_,
                                                    responsible : select.user_id,
                                                    tel : select.tel || "",
                                                    sectschoolfeecatstudcategories : select.sectschoolfeecatstudcategories,
                                                });

                                                if(!optionschoolfeecategories?.filter(val => val.sectionId == this.state.section?.id || val.transportId == this.state.transport?.id)[0]?.transportId){
                                                    this.setState({
                                                        transport__ : false,
                                                    })
                                                }
                                                else{
                                                    this.setState({ transport__: true })
                                                }
                                                this.getStudentInvoice(select.value)
                                                window.scrollTo({top: 0, left: 0, behavior: 'smooth'})
                                            }
                                        }
                                        styles={Styleselect}
                                        options={optionstudents}
                                    />
                                </div>
                            </div>
                            
                            {
                               (this.state.transport__ == true) &&(
                                <div className=" mt-1">
                                    <label className="font-monospace fw-normal"><span>Paiement<span className="text-danger">*</span></span></label>
                                    <Select
                                        {...selectMenuProps}
                                        onChange={
                                            (select) => {
                                                this.setState({
                                                    sectionschoolfeecategoryId : select.value,
                                                    price : select.price,
                                                })
                                                window.scrollTo({top: 0, left: 0, behavior: 'smooth'})
                                            }
                                        }
                                        styles={Styleselect}
                                        options={optionschoolfeecategories}
                                    />
                                </div>
                                )
                            }
                            
                            

                            <div className="form-group mt-0 mb-0">
                                <div className="form-group">
                                    
                                    <div className="row">
                                        <div className="col-7">
                                            <label className="font-monospace fw-normal"><span>{ displayName("Mois", "Trimestre") }<span className="text-danger">*</span></span></label>
                                            <div className=" ">
                                            <Select
                                                {...selectMenuProps}
                                                isMulti
                                                value={this.state.monthsSelected}
                                                onChange={(selects) => {
                                                    const selected = selects || [];

                                                    this.setState({
                                                        monthsSelected: selected,
                                                        price: selected.length > 0
                                                            ? selected[0].price
                                                            : null
                                                    });

                                                    window.scrollTo({
                                                        top: 0,
                                                        left: 0,
                                                        behavior: 'smooth'
                                                    });
                                                }}
                                                components={{
                                                    DropdownIndicator: () => null,
                                                    IndicatorSeparator: () => null,
                                                }}

                                                options={trimesections?.sort(
                                                    (a, b) => a.trimesterId < b.trimesterId ? -1 : 1
                                                )}
                                                // styles={Styleselect}
                                            />
                                            </div>
                                        </div>
                                        
                                         <div className="mt-1 col-5">
                                            <label htmlFor="nom-id-icon">
                                                <span>Montant payé<span className="text-danger">*</span></span>
                                                {totalSelectedAmount > 0 && (
                                                    <span className="text-primary">
                                                         {totalSelectedAmount.toLocaleString()}
                                                    </span>
                                                )}
                                            </label>
                                            <input type="number" className="form-control form-control-sm"  placeholder=""  onChange={this.handleInputMax} name="pay_mount"  value={this.state.pay_mount} id="nom-id-icon" />
                                         </div>

                                        <div className="mt-1 col-6">
                                            <label htmlFor="nom-id-icon">
                                                Date paiement</label>
                                            <input type="date" className="form-control form-control-sm" placeholder={ new Date()?.toLocaleDateString() }  onChange={(e) => { this.setState({ createdAt : e.target.value })}} name="createdAt"  value={this.state.createdAt} id="nom-id-icon" />
                                        </div>

                                        <div className="mt-1 col-6">
                                            <div className="form-group_">
                                                <label htmlFor="nom-id-icon_"><span>Télé parent<span className="text-danger">*</span></span></label>
                                                <div className="row_">
                                                        <div className="col-11">
                                                        <input type="number" className="form-control form-control-sm" placeholder=""  onChange={(v) => { this.setState({ tel : v.target.value })}} name="tel"  value={this.state.tel} id="nom-id-icon" />
                                                        </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                        </div>
                        <div  className='schoolfee-pay-actions'>
                            <label className="schoolfee-pay-check" htmlFor="check"><input type={"checkbox"} onClick={() => this.setState({ printInvoice : !this.state.printInvoice })} id="check" /> AutoPrint</label>
                            <button className="d-none btn me-4 btn-outline-secondary btn-sm  p-0 px-1"><FeatherIcon icon="corner-down-left"></FeatherIcon> Vider</button>
                            <button onClick={() => this.storeShoolfee()} disabled={ this.state.btn } className="btn btn-sm btn-outline-primary schoolfee-pay-save">
                                <div className='d-flex justify-content-center'>
                                    {
                                        this.state.btn && (
                                            <ReactLoading type="spokes" color="black" height={20} width={15} />
                                        )
                                    }
                                    <span>{ !this.state.btn && (<FeatherIcon icon="check-square" size={13} />)} Sauvegarder</span>
                                </div>
                            </button>
                        </div>
                    </div>
                </div>

                <div className="col-lg-8 col-12 m-0 p-0">
                     <div className="schoolfee-pay-ledger">
                        <div className="borderForm schoolfee-pay-card">
                            <div>Paiements <strong>{this.state.student_?.user?.last_name} {this.state.student_?.user?.family_name} {this.state.student_?.user?.first_name}</strong> {this.state.student_?.sectionclasse?.classe?.short_entitled_class } {this.state.student_?.sectionclasse?.title } {this.state.student_?.sectionclasse?.section?.short_entitled_section }</div>
                            <div>
                                <table className="table schoolfee-pay-table">
                                    <thead>
                                        <tr>
                                            <th style={{ fontSize : 10}}>Fac.</th>
                                            <th style={{ fontSize : 10}}>Paiement</th>
                                            <th style={{ fontSize : 10}}>{ displayName("Mois", "Trimestre") }</th>
                                            <th style={{ fontSize : 10}}>Montant</th>
                                            <th style={{ fontSize : 10}}>Dette</th>
                                            <th style={{ fontSize : 10}}>Date</th>
                                        </tr>
                                    </thead>
                                    
                                    <tbody>
                                    {
                                        Object.entries(
                                            (this.state.invoiceStudent || [])?.reduce((acc, school) => {
                                                const yearId = school?.year?.id || 0;
                                                const yearName = school?.year?.year || "Année inconnue";
                                                const key = `${yearId}__${yearName}`;

                                                if (!acc[key]) acc[key] = [];
                                                acc[key].push(school);

                                                return acc;
                                            }, {})
                                        )
                                        .sort(([a], [b]) => {
                                            const yearIdA = Number(a.split("__")[0]);
                                            const yearIdB = Number(b.split("__")[0]);
                                            return yearIdB - yearIdA;
                                        })
                                        
                                        .map(([key, schools]) => {
                                            const yearName = key.split("__")[1];

                                            const totals = schools.reduce((acc, school) => {
                                                const currency = school.sectionschoolfeecategory?.currency || "";
                                                acc[currency] = (acc[currency] || 0) + Number(school?.pay_mount || 0);
                                                return acc;
                                            }, {});

                                            return (
                                                <React.Fragment key={key}>
                                                    <tr>
                                                        <td colSpan="6" style={{ fontSize: 11, fontWeight: "bold", background: "#eee" }}>
                                                            Année scolaire : {yearName} — Total :{" "}
                                                            {
                                                                Object.entries(totals).map(([currency, total]) => (
                                                                    <span key={currency} style={{ marginRight: 10 }}>
                                                                        {total.toLocaleString()} {currency}
                                                                    </span>
                                                                ))
                                                            }
                                                        </td>
                                                    </tr>

                                                    {
                                                        schools.filter(v => v.year?.id == yearId)
                                                            .sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt))
                                                            .map((school, index) => (
                                                                <tr key={school.id || index}>
                                                                    <td style={{ fontSize: 10 }} onClick={() => this.showModal(school)}>
                                                                        <span type="button">{school.invoice}</span>
                                                                    </td>

                                                                    <td style={{ fontSize: 10 }} onClick={() => this.showModal(school)}>
                                                                        <span type="button">
                                                                            {school.sectionschoolfeecategory?.schoolfeecategory?.category}{" "}
                                                                            {school?.sectionschoolfeecategory?.transport?.axe || ""}
                                                                        </span>
                                                                    </td>

                                                                    <td style={{ fontSize: 10 }} onClick={() => this.showModal(school)}>
                                                                        <span type="button">
                                                                            {displayName(
                                                                                school?.month?.month,
                                                                                school?.trimesectschool?.trimester?.short_trimester
                                                                            )}
                                                                        </span>
                                                                    </td>

                                                                    <td style={{ fontSize: 10 }} onClick={() => this.showModal(school)}>
                                                                        <span type="button">
                                                                            {school?.pay_mount?.toLocaleString()}{" "}
                                                                            {school.sectionschoolfeecategory?.currency}
                                                                        </span>
                                                                    </td>

                                                                    <td
                                                                        style={{
                                                                            fontSize: 10,
                                                                            color: school?.remaining_amount > 0 ? "red" : "black"
                                                                        }}
                                                                        onClick={() => this.showModal(school)}
                                                                    >
                                                                        <span type="button">
                                                                            {school?.remaining_amount > 0
                                                                                ? school.remaining_amount.toLocaleString()
                                                                                : ""}{" "}
                                                                            {school?.remaining_amount > 0
                                                                                ? school.sectionschoolfeecategory?.currency
                                                                                : ""}
                                                                        </span>
                                                                    </td>

                                                                    <td style={{ fontSize: 10 }} onClick={() => this.showModal(school)}>
                                                                        <span type="button">
                                                                            {new Date(school.createdAt).toLocaleDateString("en-GB")}{" "}
                                                                            {new Date(school.createdAt).getHours()}h:
                                                                            {String(new Date(school.createdAt).getMinutes()).padStart(2, "0")}'
                                                                        </span>
                                                                    </td>
                                                                </tr>
                                                            ))
                                                    }
                                                </React.Fragment>
                                            );
                                        })
                                    }
                                    </tbody>
                                </table>
                            </div>
                        </div>
                        <div className="">
                            <div className="schoolfee-pay-ledger">
                                <div className="borderForm schoolfee-pay-card">
                                    <div>Paiements <strong>{this.state.selectedDate ? new Date(this.state.selectedDate).toLocaleDateString() : "Aujourd'hui"}</strong> { valprice } <input type="date" value={this.state.selectedDate} onChange={(e) => this.displayInvoice(e.target.value)} /> <span className="text-danger">{ this.state.loading ? 'Chargement...' : '' }</span></div>
                                    <table className="table schoolfee-pay-table">
                                        <thead>
                                            <tr>
                                                <th style={{ fontSize : 10}}>Fac.</th>
                                                <th style={{ fontSize : 10}}>Eleve</th>
                                                <th style={{ fontSize : 10}}>Classe</th>
                                                <th style={{ fontSize : 10}}>Paiement</th>
                                                <th style={{ fontSize : 10}}>{ displayName("Mois", "Trimestre") }</th>
                                                <th style={{ fontSize : 10}}>Montant</th>
                                                <th style={{ fontSize : 10}}>Dette</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                        {
                                            Object.entries(
                                                (this.state.invoices || []).reduce((acc, school) => {
                                                    // this.state.invoices?.filter(v => v.staff?.id == user?.staff?.id) || []).reduce((acc, school) => {
                                                    const yearId = school?.year?.id || 0;
                                                    const yearName = school?.year?.year || "Année inconnue";
                                                    const key = `${yearId}__${yearName}`;

                                                    if (!acc[key]) acc[key] = [];
                                                    acc[key].push(school);

                                                    return acc;
                                                }, {})
                                            )
                                            .sort(([a], [b]) => Number(b.split("__")[0]) - Number(a.split("__")[0]))
                                            .map(([key, schools]) => {
                                                const yearName = key.split("__")[1];

                                                const totals = schools.reduce((acc, school) => {
                                                    const currency = school.sectionschoolfeecategory?.currency || "";
                                                    acc[currency] = (acc[currency] || 0) + Number(school?.pay_mount || 0);
                                                    return acc;
                                                }, {});

                                                return (
                                                    <React.Fragment key={key}>
                                                        <tr>
                                                            <td
                                                                colSpan="7"
                                                                style={{
                                                                    fontSize: 11,
                                                                    fontWeight: "bold",
                                                                    background: "#eee"
                                                                }}
                                                            >
                                                                Année scolaire : {yearName} — Total :{" "}
                                                                {Object.entries(totals).map(([currency, total]) => (
                                                                    <span key={currency} style={{ marginRight: 12 }}>
                                                                        {total.toLocaleString()} {currency}
                                                                    </span>
                                                                ))}
                                                            </td>
                                                        </tr>

                                                        {
                                                            schools
                                                                .sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt))
                                                                .map((school, index) => (
                                                                    <tr key={school.id || index}>
                                                                        <td style={{ fontSize: 10 }} title="Envoyer SMS au parent" onClick={() => this.showModalSendSms(school.sm?.id)}>
                                                                            <span type="button">
                                                                                {school?.sm?.status === 0
                                                                                    ? <input type="checkbox" />
                                                                                    : school.invoice}
                                                                            </span>
                                                                        </td>

                                                                        <td style={{ fontSize: 10 }} onClick={() => this.showModal(school)}>
                                                                            <span type="button">
                                                                                {school.student?.user?.last_name}{" "}
                                                                                {school.student?.user?.family_name}{" "}
                                                                                {school.student?.user?.first_name}
                                                                            </span>
                                                                        </td>

                                                                        <td style={{ fontSize: 10 }} onClick={() => this.showModal(school)}>
                                                                            <span type="button">
                                                                                {school.student?.sectionclass?.class?.short_entitled_class}{" "}
                                                                                {school.student?.sectionclass?.title}{" "}
                                                                                {school.student?.sectionclass?.section?.short_entitled_section}
                                                                            </span>
                                                                        </td>

                                                                        <td style={{ fontSize: 10 }} onClick={() => this.showModal(school)}>
                                                                            <span type="button">
                                                                                {school.sectionschoolfeecategory?.schoolfeecategory?.category}{" "}
                                                                                {school.sectionschoolfeecategory?.transport?.axe || ""}
                                                                            </span>
                                                                        </td>

                                                                        <td style={{ fontSize: 10 }} onClick={() => this.showModal(school)}>
                                                                            <span type="button">
                                                                                {displayName(
                                                                                    school?.month?.month,
                                                                                    school?.trimesectschool?.trimester?.short_trimester
                                                                                )}
                                                                            </span>
                                                                        </td>

                                                                        <td style={{ fontSize: 10 }} onClick={() => this.showModal(school)}>
                                                                            <span type="button">
                                                                                {school?.pay_mount?.toLocaleString()}{" "}
                                                                                {school.sectionschoolfeecategory?.currency}
                                                                            </span>
                                                                        </td>

                                                                        <td
                                                                            style={{
                                                                                fontSize: 10,
                                                                                color: school?.remaining_amount > 0 ? "red" : "black"
                                                                            }}
                                                                            onClick={() => this.showModal(school)}
                                                                        >
                                                                            <span type="button">
                                                                                {school?.remaining_amount > 0
                                                                                    ? school.remaining_amount.toLocaleString()
                                                                                    : ""}{" "}
                                                                                {school?.remaining_amount > 0
                                                                                    ? school.sectionschoolfeecategory?.currency
                                                                                    : ""}
                                                                            </span>
                                                                        </td>
                                                                    </tr>
                                                                ))
                                                        }
                                                    </React.Fragment>
                                                );
                                            })
                                        }
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {
                this.state.student_ && (
                    <StudentForm
                        isModal={ this.state.isModalEditStudent }
                        formData={ this.state.student_?.user }
                        student={ this.state.student_ }
                        showModal = { this.editStudentModal}
                    />
                )
            }
            {
                this.state.formData &&  (this.state.formData.id && (
                    <ShoolfeeInvoice
                        isModal={this.state.isModal} 
                        formData={this.state.formData.id}
                        // schoolfeecategory={this.state.schoolfeecategory}
                        showModal={this.showModal}
                    />
                ))
            }

            {
                this.state.isModalAdd && (
                    <StudentFormrh
                        isModal={this.state.isModalAdd} 
                        formData={null}
                        showModal={this.showModalAdd}
                    />
                )
            }

            {
                this.state.isModalCheck && (
                    <Modal
                        show={this.state.isModalCheck} 
                        onHide={() => this.showModalCheck}
                        size="md"
                        // onEntered={this.edit}
                        backdrop={"static"}>
                            <Modal.Body className="row">
                                {/* <strong>{ 'Recherche dans année scolaire  ' + (this.state.yearId ? this.state.years?.filter(year => year.id == this.state.yearId)[0]?.year: 'encours') } <span className="text-primary ms-4" type="button" onClick={this.showModalAdd}> <FeatherIcon icon="user-plus" size={13} className="text-primary" />Eleve</span></strong> */}
                                <strong>{ 'Recherche eleve' } <span className="text-primary ms-4" type="button" onClick={this.showModalAdd}> <FeatherIcon icon="user-plus" size={13} className="text-primary" />Eleve</span></strong>
                                <div className="text-center"><span className="text-danger text-small">{ this.state.error }</span></div>
                                <div className="form-group col-md-12 mt-2">
                                    <label className="font-monospace fw-normal">Nom de l'eleve</label>
                                    <div className="input-group">
                                       <input type="text" className="form-control form-control-sm" placeholder="Tapez le nom de l'eleve"  onChange={this.handleInputChangeSearch} name="search"  value={this.state.search} id="nom-id-icon" />
                                    </div>
                                </div>
                                <div className="table-responsive student-file-table">
                                    <table className="" style={{ width : "100%" }}>
                                        <thead>
                                            <tr>
                                                <th style={{ fontSize : 10}}>Eleve</th>
                                                <th style={{ fontSize : 10}}>Classe</th>
                                                <th style={{ fontSize : 10}}>Annee</th>
                                                <th style={{ fontSize : 10}}>#</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                        {
                                            this.state.searchs?.sort((a, b) => `${a?.user?.last_name} ${a?.user?.family_name} ${a?.user?.first_name}`.localeCompare(`${b?.user?.last_name} ${b?.user?.family_name} ${b?.user?.first_name}`)).map((student, index) => (
                                                <tr>
                                                    <td style={{ fontSize : 10, cursor: student?.year?.status === 1 ? "pointer" : "default" }} onClick={(student?.year?.status === 1 || this.state.yearId ==  student?.year?.id && student?.year?.status == 0) ? () => this.showModalCheck(student) : undefined}><span type="button">{ student?.user?.last_name } { student?.user?.family_name } { student?.user?.first_name }</span></td>
                                                    <td style={{ fontSize : 10, cursor: student?.year?.status === 1 ? "pointer" : "default" }} onClick={student?.year?.status === 1 ? () => this.showModalCheck(student) : undefined}><span type="button">{ student?.sectionclass?.class?.short_entitled_class } { student?.sectionclass?.title } { student?.sectionclass?.section?.short_entitled_section }</span></td>
                                                    <td style={{ fontSize : 10}}><span className={student?.year?.status === 1 ? "text-primary" : "text-danger"}>{ student?.year?.year || "Année non spécifiée" }</span></td>
                                                    <td style={{ fontSize : 10}}>{student?.year?.status === 1 ? (<span type="button" onClick={() => this.showModalCheck_edit(student)}><FeatherIcon icon="edit" color="text-primary" size={13} /></span>) : <span className=" text-danger">Archivé</span>}</td>
                                                </tr>
                                            ))
                                        }
                                        </tbody>
                                    </table>
                                    { (this.state.loadingSearch && this.state.search?.length > 0) && (<FeatherIcon className="user-search-spin" icon="loader" />)}
                                </div>
                            </Modal.Body>
                            <Modal.Footer>
                                <button onClick={() => this.showModalCheck()} className="btn btn-outline-secondary btn-sm p-0 px-1"><FeatherIcon icon="corner-down-left"></FeatherIcon> Fermer</button>
                            </Modal.Footer>
                    </Modal>
                )
            }
            
        </div>
        )
    }
}
export default Formschoolfee;